import axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";
import React, { useEffect, useState } from "react";
import "../../../pages/css/BillingGroupPricing/BillingGroupPricing.css"
import { Checkbox } from "@fluentui/react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { qsStringify } from "src/utilities/helper";
import Select from "react-select"
import Loader from "src/components/common/Loader";
import logger from '../../../utilities/logging';

interface utilityProps {
    UtilityID: number
    UtilityName: string
    ContractID: number
    ContractExpirationDate: string
}
interface profitCenterprops {
    id: number
    text: string
}
interface responsesProps {
    ResponseID: number
    ResponseText: string
    ResponseCode: string
    ResponseUnitType: string
    AvailableResponseID: number
    ResponseHelp: string
    QuantityRequired: boolean | null
    FootageRequired: boolean | null
    TimeRequired: boolean | null
    VisibleInClient: boolean | null
    QuantityWarningThreshold: number | null
    ProfitCenterUtilityID: number
    AfterHoursOnly: boolean | null //
    AfterHoursWeekends: boolean | null //
    AfterHoursHolidays: boolean | null //

}
interface EditAvailableResponseProps {
    Utilities: utilityProps[]
    billinggroupid: number
    close: Function
    refresh: Function
}

function EditAvailableResponse(props: EditAvailableResponseProps) {
    const [responses, setResponses] = useState<responsesProps[]>([{
        ResponseID: 0,
        ResponseText: "",
        ResponseCode: "",
        ResponseUnitType: "",
        AvailableResponseID: 0,
        ResponseHelp: "",
        QuantityRequired: false,
        FootageRequired: false,
        TimeRequired: false,
        VisibleInClient: true,
        QuantityWarningThreshold: 0,
        ProfitCenterUtilityID: 0,
        AfterHoursOnly: false,
        AfterHoursWeekends: false,
        AfterHoursHolidays: false
    }])
    const billingUtilities = props.Utilities
    const billinggroupid = props.billinggroupid
    const close = props.close
    const refresh = props.refresh
    const [utilityID, setUtilityId] = useState(billingUtilities[0].UtilityID)
    const [selectedRow, setSelectedRow] = useState<number>(-99)
    const [responseDesc, setResponseDesc] = useState("")
    const [quantityRequired, setQuantityRequired] = useState(false)
    const [footageRequired, setFootageRequired] = useState(false)
    const [timeRequired, setTimeRequired] = useState(false)
    const [quantityWarningThreshold, setQuantityWarningThreshold] = useState<string>('')
    const [profitCenters, setProfitCenters] = useState<profitCenterprops[]>([{ id: 0, text: "" }])
    const [profitCenterID, setProfitCenterID] = useState(0)
    const [filter, setFilter] = useState<keyof responsesProps>("ResponseID")
    const [acdc, setACDC] = useState(1)
    const [adminOnly, setAdminOnly] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [deleteConfirmation, setDeleteConfirmation] = useState(false)

    // New states for the additional fields for task 3238
    const [afterHoursOnly, setAfterHoursOnly] = useState(false);
    const [afterHoursWeekends, setAfterHoursWeekends] = useState(false);
    const [afterHoursHolidays, setAfterHoursHolidays] = useState(false);

    // console.log(responses)

    //update to get active responses
    const GetResponses = () => {
        axios.get(process.env.REACT_APP_API_URL + `/api/css/active/locator/${utilityID}/${profitCenterID}`, AxiosConfig.configValue("min"))
            .then((res) => {
                console.log(res.data)
                setResponses(res.data)
            })
    }
    const GetProfitCenters = () => {
        axios.get(process.env.REACT_APP_API_URL + `/api/css/billing/ProfitCenter/${billinggroupid}`, AxiosConfig.configValue("min"))
            //r-18-lint-cn
            //eslint-disable-next-line
            .then((res) => (setProfitCenters(res.data), setProfitCenterID(res.data[0].id)))
    }
    const editAvailableResponse = () => {
        if (selectedRow !== -99) {
            axios.post(process.env.REACT_APP_API_URL + '/api/css/locator/EditAvailableLocatorResponse', qsStringify({
                AvailableResponseId: selectedRow,
                QuantityRequired: quantityRequired,
                FootageRequired: footageRequired,
                TimeRequired: timeRequired,
                Description: responseDesc,
                QuantityWarningThreshold: Number(quantityWarningThreshold),
                AdminOnly: adminOnly,
                AfterHoursOnly: afterHoursOnly,                  // Include new field for task 3238
                AfterHoursWeekends: afterHoursWeekends,          // Include new field for task 3238
                AfterHoursHolidays: afterHoursHolidays           // Include new field for task 3238
            }), AxiosConfig.configValue())
                //r-18-lint-cn
                //eslint-disable-next-line
                .then((res) => {
                    refresh()
                    AxiosConfig.checkResponse(
                        res,
                        { alertOnSuccess: true, successMessage: "Updated Available Response!", showSnackbar: true, snackBar: { manual: true } }
                    )
                    GetResponses()
                })
                .finally(() => (setIsLoading(false)))
                .catch((error) => {
                    alert("There was an error Editing and Available Response");
                    logger.Error({
                        EventMessage: `BillingGroupPricing -> EditAvailableResponse -> Error : ${JSON.stringify(error)}`,
                        EventCategory: "httprequest"
                    });
                    AxiosConfig.handleError(error);
                })
        }
        else {
            alert("Invalid Response")
            setIsLoading(false)
        }
    }
    const deleteAvailableResponse = (id: number) => {
        axios.get(process.env.REACT_APP_API_URL + '/api/css/locator/DeleteAvailableLocatorResponse/' + id, AxiosConfig.configValue())
            //r-18-lint-cn
            //eslint-disable-next-line
            .then((res) => {
                refresh()
                AxiosConfig.checkResponse(
                    res,
                    { alertOnSuccess: true, successMessage: "Deleted Available Response", showSnackbar: true, snackBar: { manual: true } }
                )
                setSelectedRow(-99)
                setResponseDesc("")
                setQuantityRequired(false)
                setFootageRequired(false)
                setTimeRequired(false)
                setAdminOnly(true)
                setQuantityWarningThreshold('')
                GetResponses()

            })
            .finally(() => (setIsLoading(false)))
            .catch((error) => {
                alert("There was an error Editing and Available Response");
                logger.Error({
                    EventMessage: `BillingGroupPricing -> EditAvailableResponse -> Error : ${JSON.stringify(error)}`,
                    EventCategory: "httprequest"
                });
                AxiosConfig.handleError(error);
                setIsLoading(false)
            })
    }
    const selectedRowChange = (
        rowID: number,
        Description: null | string,
        quantityRequired: boolean | null,
        footageRequired: boolean | null,
        timeRequired: boolean | null,
        adminOnly: boolean | null,
        quantityWarningThreshold: string | null,
        afterHoursOnly: boolean | null, // Include new field for task 3238
        afterHoursWeekends: boolean | null, // Include new field for task 3238
        afterHoursHolidays: boolean | null  // Include new field for task 3238
    ) => {
        setSelectedRow(rowID)
        setResponseDesc(Description ?? "")
        setQuantityRequired(quantityRequired ?? false)
        setFootageRequired(footageRequired ?? false)
        setTimeRequired(timeRequired ?? false)
        setAdminOnly(adminOnly ?? true)
        setQuantityWarningThreshold(quantityWarningThreshold ?? '')
        setAfterHoursOnly(afterHoursOnly ?? false);
        setAfterHoursWeekends(afterHoursWeekends ?? false);
        setAfterHoursHolidays(afterHoursHolidays ?? false);
    }
    //add delete function
    useEffect(() => {
        if (profitCenterID !== 0) {
            GetResponses()
        }
        setSelectedRow(-99)
        //r-18-lint-cn
        //eslint-disable-next-line
    }, [utilityID, profitCenterID])
    useEffect(() => {
        GetProfitCenters()
        //r-18-lint-cn
        //eslint-disable-next-line
    }, [])

    const handleAfterHoursOnlyClick = () => {
        // Toggle the afterHoursOnly state
        setAfterHoursOnly(!afterHoursOnly);

        // If afterHoursOnly is being unchecked, also uncheck weekends and holidays
        if (afterHoursOnly) {
            setAfterHoursWeekends(false);
            setAfterHoursHolidays(false);
        }
    };

    return (
        <div className="locatorResponseModal">
            <div className="locatorModalSelect">
                <div>
                    <span>
                        Utility:
                    </span>
                    <div>
                        <Select
                            id="select"
                            onChange={(e: any) => (setUtilityId(e.value))}
                            options={billingUtilities.map((x) => ({ value: x.UtilityID, label: x.UtilityName }))}
                            value={{ label: billingUtilities.find(x => x.UtilityID === utilityID)?.UtilityName, value: utilityID }}
                        />
                    </div>
                </div>
                <div>
                    <span>
                        Profit Center:
                    </span>
                    <div>
                        <Select
                            id="select"
                            onChange={(e: any) => setProfitCenterID(e.value)}
                            options={profitCenters.map((x) => ({ value: x.id, label: x.text }))}
                            value={{ label: profitCenters.find((x) => x.id === profitCenterID)?.text, value: profitCenterID }}
                        />
                    </div>
                </div>
            </div>
            <div className="addAvailableResponseTable">
                {
                    isLoading ?
                        <Loader title="Loading Responses..." />
                        :
                        <Table>
                            <thead>
                                <tr>
                                    <th onClick={() => filter === "ResponseID" ? setACDC(-1 * acdc) : (setFilter("ResponseID"), setACDC(1))}>
                                        Response ID
                                        <span className="material-icons">unfold_more</span>
                                    </th>
                                    <th onClick={() => filter === "ResponseText" ? setACDC(-1 * acdc) : (setFilter("ResponseText"), setACDC(1))}>
                                        Response Text
                                        <span className="material-icons">unfold_more</span>
                                    </th>
                                    <th onClick={() => filter === "ResponseCode" ? setACDC(-1 * acdc) : (setFilter("ResponseCode"), setACDC(1))}>
                                        Response Code
                                        <span className="material-icons">unfold_more</span>
                                    </th>
                                    <th onClick={() => filter === "ResponseUnitType" ? setACDC(-1 * acdc) : (setFilter("ResponseUnitType"), setACDC(1))}>
                                        Response Unit Type
                                        <span className="material-icons">unfold_more</span>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {responses.sort((a, b) => (a[filter] ?? '') > (b[filter] ?? '') ? 1 * acdc : a[filter] === b[filter] ? 0 : -1 * acdc).map((x) =>
                                    <tr
                                        key={x.AvailableResponseID}
                                        onClick={() => selectedRowChange(
                                            x.AvailableResponseID,
                                            x.ResponseHelp,
                                            x.QuantityRequired,
                                            x.FootageRequired,
                                            x.TimeRequired,
                                            x.VisibleInClient,
                                            x.QuantityWarningThreshold ? x.QuantityWarningThreshold.toString() : '',
                                            x.AfterHoursOnly,  // Pass the new values here
                                            x.AfterHoursWeekends,  // Pass the new values here
                                            x.AfterHoursHolidays   // Pass the new values here
                                        )}
                                        className={x.AvailableResponseID === selectedRow ? "rowHighlight" : ""}
                                    >
                                        <td>{x.ResponseID}</td>
                                        <td>{x.ResponseText}</td>
                                        <td>{x.ResponseCode}</td>
                                        <td>{x.ResponseUnitType}</td>
                                        <td onClick={() => (setSelectedRow(x.AvailableResponseID), setDeleteConfirmation(true))}><span className="material-icons">delete</span></td>
                                    </tr>)
                                }
                            </tbody>
                        </Table>
                }
            </div>
            <div className="locatorDescriptionText">
                <div>
                    <span>Description:</span>
                </div>
                <Form.Control value={responseDesc} onChange={(e) => setResponseDesc(e.target.value)} as="textarea" />
            </div>
            <div className="locatorDescriptionInput">
                <Checkbox checked={quantityRequired} onChange={() => setQuantityRequired(!quantityRequired)} label="Quantity Required" />
                <Checkbox checked={footageRequired} onChange={() => setFootageRequired(!footageRequired)} label="Footage Required" />
                <Checkbox checked={timeRequired} onChange={() => setTimeRequired(!timeRequired)} label="Time Required" />
                <Checkbox checked={!adminOnly} onChange={() => setAdminOnly(!adminOnly)} label="Admin Only" />
                {/* New checkboxes for the additional fields for task 3238 */}
                {/* New checkboxes for the after hours fields for task 3238 */}
                <Checkbox
                    checked={afterHoursOnly}
                    onChange={handleAfterHoursOnlyClick}
                    label="After Hours Only"
                />
                <Checkbox
                    disabled={!afterHoursOnly}
                    checked={afterHoursWeekends && afterHoursOnly}
                    onChange={() => setAfterHoursWeekends(!afterHoursWeekends)}
                    label="After Hours Weekends"
                />
                <Checkbox
                    disabled={!afterHoursOnly}
                    checked={afterHoursHolidays && afterHoursOnly}
                    onChange={() => setAfterHoursHolidays(!afterHoursHolidays)}
                    label="After Hours Holidays"
                />
            </div>
            <div className="locatorNumberInput">
                <div>
                    <span>Quantity Warning Threshold:</span>
                </div>
                <Form.Control type="text" value={quantityWarningThreshold} onChange={(e) => setQuantityWarningThreshold(e.target.value.replace(/([^0-9])/g, ''))} />
            </div>
            <div className="responseModalButtons">
                <Button variant={selectedRow === -99 ? "outline-dark" : "primary"} disabled={selectedRow === -99} onClick={() => (editAvailableResponse(), setIsLoading(true))}>Update</Button>
                <Button variant="secondary" onClick={() => close()}>Close</Button>
            </div>
            <Modal show={deleteConfirmation}>
                <Modal.Header>
                    <h5>Are you sure you want to delete this available response?</h5>
                </Modal.Header>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => (deleteAvailableResponse(selectedRow), setDeleteConfirmation(false), setIsLoading(true))}>Yes</Button>
                    <Button variant="secondary" onClick={() => setDeleteConfirmation(false)}>No</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default EditAvailableResponse